import { useRef, useState } from 'react'
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

import axios from 'axios'
import clsx from 'clsx'

import { KTSVG } from '../../../../../../../../_metronic/helpers';
import { useDOCLabelFormView } from './DOCLabelFormContextProvider';
import { useFormikContext } from 'formik';
import { cloneDeep, pickBy } from 'lodash';
import { initDOCLabelSiteValues } from '../core';

const API_URL = process.env.REACT_APP_API_URL

const acceptXLSFiles = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",                               
].join(',');;


export const DOCLabelTemplateUploader = () => {

  const { isDoor, initValues } = useDOCLabelFormView();
  const { companyName } = initValues;

  const fileInput = useRef<HTMLInputElement>(null);
  const [status_message, setStatus] = useState('');
  const [isUploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const { setFieldValue } = useFormikContext();

  const [ { canDrop, isOver}, dropRef] = useDrop({
    accept: [NativeTypes.FILE],
    drop: (item: any, monitor) => {        
      if (! (item && item.hasOwnProperty('files') && Array.isArray(item.files))) {
        return;
      }
      const { files } = item;                
      files.forEach((file: any) => {
        processFile(file);
      })                            
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })

  const processFile = async (file: any) => {
    const data = new FormData()
    data.append('media', file);

    setStatus('');
    setProgress(0);
    setUploading(true);

    async function doFileUpload(payload: any) {
      await axios.post(
        `${API_URL}/${isDoor ? 'DoorFileProcessServlet' : 'FileProcessServlet'}`, 
        payload, 
        { 
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            if (! (progressEvent && progressEvent.total)) return;
            const progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
            setProgress(progress);            
          },
        }
      )            
      .then( res => {            
        if (! (res && res.data)) {
          console.error(res);    
          return;
        }

        const { success, message, sitesModels } = res.data;
        if (! (success)) {                    
          setStatus(message ? message : 'File upload error');
          return;                        
        } 

        if (! (sitesModels && sitesModels.length > 0)) {
          setStatus('No sites returned');
          setFieldValue('totalLabelQuantity', 0);
          setFieldValue('siteDetails', [{
            ...cloneDeep(initDOCLabelSiteValues),
            installerName: companyName
          }]);
          return;
        }

        let siteDetails = sitesModels.map((o : any) => ({ 
          ...pickBy(o, (value, key) => (key !== 'dlmWebPhase0DetailsModels')), 
          itemDetails : o?.dlmWebPhase0DetailsModels ? 
            o.dlmWebPhase0DetailsModels.map((item:any) => {
              let obj = {...item, sizeF: '', sizeL: ''};
              // parse door size to sizeF and sizeL
              if (isDoor && obj?.size) {
              let matches = obj.size.match(/^(.*)\((F|L)\)(.*)\((F|L)\)/);
                if (matches) {
                  Object.assign(obj, {
                    [`size${matches[2]}`] : matches[1].trim(),
                    [`size${matches[4]}`] : matches[3].trim(),
                  })
                }
              }
              return obj;
            })
            : [],
        }));                            

        setStatus(`Uploaded ${siteDetails.length} sites.`);
        setFieldValue('siteDetails', siteDetails);      
      })
      .catch(err => {
        console.error(err);
      })
      .finally(()=> {
        setUploading(false);
      })
    }

    doFileUpload(data);                
  }
  
  const processFileUpload = (evt : any) => {      
      const { files } = evt.target;
      // iterate files list
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files.item(i)                
          processFile(file);
        }            
      }      
      if( fileInput.current) {
        fileInput.current.value = '';
      }        
  };

  const MessageArea = () => {
    if (isUploading) {
      return <span className='text-muted fs-9'>Uploading file ...</span>
    }    
    if (status_message) {
      return <span className='text-danger fs-9'>{status_message}</span>
    }
    return <span className='text-muted fs-9'>Upload template file.</span>            
  }

  return (              
  <div className="position-relative mb-1">
    <div 
      ref={dropRef} 
      className={clsx("w-100", {'bg-gray-200' : (canDrop && isOver)})}
      onClick={() => { 
          if (! fileInput.current) return;
          fileInput.current.click()
      }}
    >
      <input
        ref={fileInput}
        onChange={processFileUpload}
        type="file"
        style={{ display: "none" }}
        accept={acceptXLSFiles}
        multiple={false}          
      />
      <label className='btn btn-outline btn-outline-dashed btn-outline-default py-1 px-2 d-flex flex-column'>
        <div className="d-flex flex-row align-items-center gap-2 lh-1">
          <KTSVG path='/media/icons/duotune/files/fil018.svg' className='svg-icon-2x text-primary' />
          <div className='fw-bold text-start lh-1 pe-5'>
            <div className='text-dark fw-bolder d-block fs-7'>
              Upload Site Details
            </div>
            <MessageArea />                            
          </div>                                        
        </div>                    
        {isUploading && 
        <div style={{height:"4px"}} className="my-1">
          <div className="progress" style={{height:"2px"}}>
            <div className="progress-bar progress-bar-sm progress-bar-striped progress-bar-animated " role="progressbar" style={{width: `${progress}%`}} aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}></div>
          </div>    
        </div>
        }                                    
      </label>
    </div>                        
  </div>      
  )
}